import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { environment } from '@app/env';

//ignore logs on production
if (environment.production)
  console.trace = console.log = console.warn // = console.error
    = function (...args: any[]) { };

ModuleRegistry.registerModules([AllCommunityModule]);
platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));
